import {
  Box,
  Button,
  Column,
  Columns,
  Inline,
  Stack,
} from 'braid-design-system';

interface CajaButtonsProps {
  isMobileView: boolean;
  backButtonComponent: JSX.Element | undefined;
  previewButtonComponent: JSX.Element | undefined;
  isPaymentInProgress: boolean;
  handlePayAndPostButtonClick: () => void;
  postAdButtonText: string;
}

export const CajaButtons = ({
  isMobileView,
  backButtonComponent,
  previewButtonComponent,
  isPaymentInProgress,
  handlePayAndPostButtonClick,
  postAdButtonText,
}: CajaButtonsProps) => {
  if (isMobileView) {
    return (
      <Box width="full">
        <Stack space="xsmall">
          {backButtonComponent}
          {previewButtonComponent}
          <Button
            variant="solid"
            tone="brandAccent"
            loading={isPaymentInProgress}
            onClick={handlePayAndPostButtonClick}
            id="next-page-button"
          >
            {postAdButtonText}
          </Button>
        </Stack>
      </Box>
    );
  } else if (backButtonComponent) {
    return (
      <Box paddingX={['gutter', 'none']}>
        <Columns space="xsmall" alignY="center">
          <Column width="content">{backButtonComponent}</Column>
          <Column>
            <Inline space="small" alignY="center" align="right">
              {previewButtonComponent}
              <Button
                variant="solid"
                tone="brandAccent"
                loading={isPaymentInProgress}
                onClick={handlePayAndPostButtonClick}
                id="next-page-button"
              >
                {postAdButtonText}
              </Button>
            </Inline>
          </Column>
        </Columns>
      </Box>
    );
  }
  return (
    <Box paddingX={['gutter', 'none']}>
      <Inline space="small" alignY="center" align="left">
        <Button
          variant="solid"
          tone="brandAccent"
          loading={isPaymentInProgress}
          onClick={handlePayAndPostButtonClick}
          id="next-page-button"
        >
          {postAdButtonText}
        </Button>
        {previewButtonComponent}
      </Inline>
    </Box>
  );
};
